function BundleComposer() {
    var $bundleComposition = jQuery('.bundle-composition');
    if (!$bundleComposition.length) {
        return;
    }

    var productId = $bundleComposition.data('product-id');
    if (!productId) {
        console.log('Missing product id');
        return;
    }

    if (typeof bundleComposerTotalSpecials == 'undefined') {
      return;
    }

    if (typeof bundleComposerTotal == 'undefined') {
      return;
    }


    var $drawer = jQuery('#BundleDrawer');
    var $addToCartButton = jQuery('button[name="add"]');
    var $selectedSlot = null;
    var $radioBoxes = $drawer.find('input');

    var drawer = new theme.Drawers('BundleDrawer', 'bundle');

    var bundleTitles = {};
    var bundleTypes = {};

    function hookAddToCart() {
        $addToCartButton.prop('disabled', true);

        jQuery('.shopify-payment-button').remove();

        $addToCartButton.on('click', function(e) {
            e.preventDefault();

            $addToCartButton.addClass('btn--loading');
            jQuery.ajax({
                url:'/cart/add.js',
                type: 'post',
                dataType: 'json',
                data: {
                    items: [
                        {
                            id: productId,
                            quantity: 1,
                            properties: bundleTitles
                        }

                    ]
                }
            }).always(function() {
                $addToCartButton.removeClass('btn--loading');
                $('body').trigger('added.ajaxProduct', $addToCartButton);
                $addToCartButton.prop('disabled', true);
                $drawer.find('input:checked').prop('checked', false);
            });
        });
    }

    function isProductSpecial(type) {
        return type.indexOf('Special') !== -1;
    }

    function hookRadioboxes() {
        $radioBoxes.on('click', function(e) {
            var $input = $(this);

            if (!$input.hasClass('disabled')) {
                return;
            }

            e.preventDefault();
            $input.prop('checked', false);
        });
    }

    function hookValidate() {
        $drawer.find('.btn--validate').on('click', function(e) {
            e.preventDefault();
          	$drawer.removeClass('drawer--is-open');
            //drawer.close();

            if ($selectedSlot === null) {
                return;
            }

            var $product = jQuery('[name="BundleDonuts-option"]:checked');
            if (!$product.length) {
                return;
            }

            var slot = $selectedSlot.data('slot');

            bundleTypes[slot] = $product.data('type');
            bundleTitles[slot] = $product.data('title');
            bundleTitles['_' + slot] =  $product.data('id');

            $selectedSlot.data('id', $product.attr('id'));
            $selectedSlot.html($product.next().html());

            var len = 0;
            for (var i in bundleTypes) {
                if (!bundleTypes.hasOwnProperty(i)) {
                    continue;
                }
                len++;
            }

            $addToCartButton.prop(
                'disabled',
                len !== bundleComposerTotal
            );

        });

        $drawer.find('.js-drawer-close').on('click', function(e) {
            e.preventDefault();
            $drawer.find('input').prop('checked', false);
          	$drawer.removeClass('drawer--is-open');
        });
    }

    function addChoices() {
        var html = '<ul class="bundle-options bundle-choices">';

        for (var i = 1; i <= bundleComposerTotal; i++) {
            html += '<li>';
            html += '<div class="bundle-option-wrapper">';
            html += '<label class="variant__button-label" data-slot="' + i + '">';
            html += 'Select option ' + i;
            html += '</label>';
            html += '</div>';
            html += '</li>';
        }

        html += '</ul>';

        $bundleComposition.html(html);
    }

    function disableSpecials(selectedSlot) {
        var specials = 0;
        for (var i in bundleTypes) {
            if (!bundleTypes.hasOwnProperty(i)) {
                continue;
            }

            var type = bundleTypes[i];
            if (!isProductSpecial(type)) {
                continue;
            }

            specials++;
        }

        $radioBoxes.each(function() {
            var $input = $(this);

            if (!isProductSpecial($input.data('type'))) {
                return;
            }

            if ((bundleTypes.hasOwnProperty(selectedSlot) && isProductSpecial(bundleTypes[selectedSlot])) ||
                specials < bundleComposerTotalSpecials) {
                $input.removeClass('disabled');
                return;
            }

            $input.addClass('disabled');
        });
    }

    function hookChoices() {
        jQuery('.bundle-choices').on('click', function(e, t) {
            if (e.target.nodeName !== 'LABEL') {
                return;
            }

            e.preventDefault();

            $selectedSlot = jQuery(e.target);

            disableSpecials($selectedSlot.data('slot'));

          	$drawer.addClass('drawer--is-open');

            var id = $selectedSlot.data('id');
            if (id) {
                jQuery('#' + id).prop('checked', true);
            } else {
                jQuery('[name="BundleDonuts-option"]:checked').prop('checked', false);
            }
        });
    }

    function enableAddToCartContainer() {
        jQuery('.bundle-composer-container').show();
    }

    hookAddToCart();
    hookRadioboxes();
    hookValidate();
    addChoices();
    hookChoices();
    enableAddToCartContainer();
}

BundleComposer();
